"use client";

import React from "react";
import { Quote, Star } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * WebsiteForCoachesAndConsultants — Section 7: Testimonial
 * Drop-in für: src/pages/WebsiteForCoachesAndConsultants/sections/CustomerTestimonials.tsx
 *
 * Sandra Meier (Frauenfeld) — passt zur Coach/Berater-Welt (eigene Website ohne Erfahrung).
 */

export default function CustomerTestimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section className="bg-secondary py-20 md:py-24">
      <div ref={ref} className={`max-w-3xl mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <Quote className="w-10 h-10 text-primary/20 mx-auto mb-6 rotate-180" strokeWidth={1.5} />

        <p className="text-2xl md:text-3xl font-medium italic text-foreground leading-relaxed mb-8">
          «Ich hatte null Erfahrung mit Websites. Mit PAGEMAKER24 war meine
          Seite in zwei Stunden online. Meine Klienten finden mich jetzt direkt
          über Google.»
        </p>

        <div className="flex items-center justify-center gap-1 text-primary mb-4">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" />)}
        </div>

        <div>
          <span className="font-bold text-foreground">Sandra Meier</span>
          <span className="text-muted-foreground mx-2">·</span>
          <span className="text-muted-foreground">
            Coachin, Frauenfeld
          </span>
        </div>
      </div>
    </section>;
}